import { Flex, Icon, Text } from '@chakra-ui/react';
import { ExternalLinkIcon } from '@heroicons/react/solid';
import { analytics } from 'pages';

type Props = {
  isActive?: boolean;
  isExternal?: boolean;
  icon?: React.FunctionComponent;
  text: string;
  size?: 'sm' | 'md';
  handleClick?: () => void;
};

export function SidenavItem({
  isActive = false,
  isExternal = false,
  icon,
  text,
  size = 'md',
  handleClick = () => {
    /* noop */
  }
}: Props): JSX.Element {
  return (
    <Flex
      align="center"
      px={4}
      py={2}
      rounded="md"
      cursor="pointer"
      gap={4}
      bg={isActive ? 'var(--highlightBg)' : 'transparent'}
      color={isActive ? 'var(--primaryTextColor)' : 'var(--secondaryTextColor)'}
      onClick={handleClick}
      transition="all 0.2s"
      role="group"
      _hover={{
        color: 'var(--primaryTextColor)'
      }}
    >
      {icon && (
        <Icon
          as={icon}
          transition="all 0.2s"
          color={isActive ? 'var(--primaryTextColor)' : 'var(--iconColor)'}
          _groupHover={{
            color: 'var(--primaryTextColor)'
          }}
        />
      )}
      <Flex align="center" gap={1}>
        <Text
          pl={icon ? 0 : 8}
          textStyle={size === 'sm' ? 'xs-medium' : 'sm-medium'}
          // onClick={() =>
          //   analytics.track(`Docs_Side Nav_Menu Item Clicked`, {
          //     surface: 'Docs',
          //     location: 'Side Nav',
          //     ClickedOn: text
          //   })
          // }
        >
          {text}
        </Text>

        {isExternal && <Icon as={ExternalLinkIcon} />}
      </Flex>
    </Flex>
  );
}
